module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Edgar Allan Poe, Jonathan  Maberry\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Edgar Allan Poe (1809–1849) was an American author and poet who profoundly influenced the mystery, horror, and science fiction genres. A master of the short story, Poe wrote many classic tales, including “The Tell-Tale Heart,” “The Murders in the Rue Morgue,” “The Pit and the Pendulum,” and “The Masque of the Red Death.” His other enduring works include the poem “The Raven” and his only completed novel, "), _c('I', [_vm._v("The Narrative of Arthur Gordon Pym of Nantucket")]), _vm._v(". ")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/vYLUyc/tc-custom/9781680575484.jpg?1737194763467",
      "alt": "This image is the cover for the book Narrative of Arthur Gordon Pym of Nantucket"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Narrative of Arthur Gordon Pym of Nantucket\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Rum, a sailing ship, and a dare…   …What could go wrong?   Edgar Allan Poe’s only complete novel, The Narrative of Arthur Gordon Pym of Nantucket is one of the first adventure stories set in and around the Antarctic, which at the time was a place of mystery and the unknown.   Pym takes us on an adventure across the seas to uncharted southern lands that are fraught with danger. With shipwrecks, murder, mutiny, and, yes, cannibalism, this tale has it all. First published in 1838, midway between Defoe’s Robinson Crusoe and Stevenson’s Treasure Island, Poe’s Pym echoes one and presages the other while delving even deeper into the darkness of men’s souls.   This new edition, with a new Foreword by New York Times best-selling author and Bram Stoker Award winner Jonathan Maberry, brings the classic tale back to life. Not for the faint of heart, Poe’s novel, which inspired H.G. Wells, Jules Verne, H.P. Lovecraft, and many others, reflects the wonder and dangers of exploring the unknown.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    WordFire Press\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0